import { render, staticRenderFns } from "./AttendanceDateApproval.vue?vue&type=template&id=49179fac&scoped=true&lang=pug&"
import script from "./scripts/AttendanceDateApproval.js?vue&type=script&lang=js&"
export * from "./scripts/AttendanceDateApproval.js?vue&type=script&lang=js&"
import style0 from "./AttendanceDateApproval.vue?vue&type=style&index=0&id=49179fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49179fac",
  null
  
)

export default component.exports